<template>
	<div class="login-page">
		<!-- 综合管理平台 -->
		<div class="login-wrap">
			<div class="login-ctn">
				<img class="logo" src="../../static/img/login/login-logo.png" alt="">
				<div class="log-form">
					<div class="log-title">综合管理平台</div>
					<div class="item" :class="{focus:userFocus||userName}">
						<input class="input" type="text" placeholder="请输入登录账号" v-model="userName"
							@focus="focusInput('userFocus')" @blur="blurInput('userFocus')">
						<i class="ico log-user"></i>
					</div>
					<div class="item" :class="{focus:passwordFocus||password}">
						<input class="input" type="password" placeholder="请输入登录密码" v-model="password"
							@focus="focusInput('passwordFocus')" @blur="blurInput('passwordFocus')">
						<i class="ico log-psw" ></i>
					</div>
					<div class="item code-box" :class="{focus:codeFocus||code}">
						<div class="code-img"></div>
						<input class="input" type="text" placeholder="请输入验证码" v-model="code"
							@focus="focusInput('codeFocus')" @blur="blurInput('codeFocus')">
						<i class="ico log-code"></i>
					</div>
					<div class="submit-btn">登录</div>
					<div class="forget-btn">
						<a href="javascript:;">忘记密码</a>
					</div>
				</div>
			</div>
			<div class="copyright">Copyright 2022-现在 中国教育技术协会网络课程建设工作委员会    粤ICP备XXXXXXXX号-1</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'login',
	components:{

	},
	data () {
		return {
			userFocus:false,
			passwordFocus:false,
			codeFocus:false,
			
			userName:'',
			password:'',
			code:'',
		}
	},
	
	created(){
		
	},
  
	computed:{
		
	},
  
	methods:{
		focusInput(key){
			this[key] = true
		},
		blurInput(key){
			this[key] = false
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/login/index1.vue